import axios from "axios";
import { GRANT_TYPES } from "shared/api/auth/constants";
import { TokenResponse } from "shared/api/mydeposit/interfaces/tokens";
import urls from "shared/api/mydeposit/urls";
import isDevEnvironment from "shared/utils/environment.utils";

export const myDepositAuthApiClient = axios.create({
    baseURL: window.APP_SETTINGS.myDepositAuthBaseUri,
});

export const getRedirectUri = (pathname: string): string => {
    const origin = isDevEnvironment()
        ? process.env.REACT_APP_MY_DEPOSIT_REDIRECT_ORIGIN_STUB
        : `${window.location.protocol}//${window.location.host}`;
    return `${origin}${pathname}`;
};

export const getMyDepositAuthorizeUri = (redirectUri: string): string =>
    `${window.APP_SETTINGS.myDepositAuthBaseUri}authorize` +
    `?response_type=code&client_id=${window.APP_SETTINGS.myDepositClientId}&redirect_uri=${redirectUri}`;

export const loginByCode = async (code: string, redirectUri: string): Promise<TokenResponse> => {
    const params = {
        code,
        redirect_uri: redirectUri,
        grant_type: GRANT_TYPES.AUTHORIZATION_CODE,
        client_id: window.APP_SETTINGS.myDepositClientId,
        client_secret: window.APP_SETTINGS.myDepositClientSecret,
    };
    const response = await myDepositAuthApiClient.post<TokenResponse>(urls.TOKEN, null, { params });

    return response.data;
};

export const refreshMyDepositAccessToken = async (refreshToken: string): Promise<TokenResponse> => {
    const params = {
        refresh_token: refreshToken,
        grant_type: GRANT_TYPES.REFRESH_TOKEN,
        client_id: window.APP_SETTINGS.myDepositClientId,
        client_secret: window.APP_SETTINGS.myDepositClientSecret,
    };
    const response = await myDepositAuthApiClient.post<TokenResponse>(urls.TOKEN, null, { params });

    return response.data;
};
